import { useEffect, useRef } from "react"
import clsx from "clsx"

import type { HTMLEmbedSlice } from "~/api/prismic/types"
import TailwindProseWrapper from "~/components/TailwindProseWrapper"
import * as RichText from "~/utils/prismic/richText"

type Props = {
  slice: HTMLEmbedSlice
}

const HTMLEmbed: React.FC<Props> = ({ slice }) => {
  const {
    html,
    iframe_title,
    add_padding,
    change_background_color,
    background_color,
  } = slice.primary
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    const iframe = iframeRef.current!
    const blob = new Blob([RichText.asText(html || [])], { type: "text/html" })
    const url = URL.createObjectURL(blob)

    iframe.src = url

    const interval = setInterval(() => {
      const height = iframe.contentWindow?.document.body.scrollHeight.toString()

      if (height) iframe.style.height = `${height}px`
    }, 2000)

    return () => {
      clearInterval(interval)
    }
  }, [html])

  const backgroundColor =
    (change_background_color && background_color) || "inherit"

  return (
    <TailwindProseWrapper>
      <div
        className="flex max-w-full justify-center overflow-x-auto"
        style={{ backgroundColor }}
      >
        <iframe
          ref={iframeRef}
          title={iframe_title || ""}
          className={clsx("mx-4 w-full", {
            "p-4": add_padding,
          })}
        />
      </div>
    </TailwindProseWrapper>
  )
}

export default HTMLEmbed
